import { createContext, useContext, useEffect, useState } from "react";

import { CartContextType, CartItem } from "../types/contexts/CartContext";
import { addToCart, deleteCart, getCart } from "./cart-context.service";
import toast from "react-hot-toast";
import { AuthContext } from "./AuthContext";

const CartContext = createContext<CartContextType>({
  cartItems: [],
  handleAddToCart: () => {},
  handleRemoveFromCart: () => {},
  clearCart: () => {},
});

const CartProvider: any = ({ children }: { children: React.ReactNode }) => {
  const [cartItems, setCartItems] = useState([] as CartItem[]);
  const { isAuthenticated } = useContext(AuthContext);

  const fetchCartItems = async () => {
    try {
      const res = await getCart();
      setCartItems(res.data.results);
    } catch (error) {
      console.log("Error fetching cart items", error);
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      fetchCartItems();
    }
  }, []);

  const handleAddToCart = async (item: CartItem) => {
    await addToCart({
      product: item.productId,
      quantity: item.quantity,
    });
    await fetchCartItems();
    toast.success("Product added to cart successfully.");
  };

  const handleRemoveFromCart = async (itemId: string) => {
    await deleteCart(itemId);
    await fetchCartItems();
  };

  const clearCart = async () => {
    console.log("clear cart");
    // Implement clear cart logic here
    setCartItems([]);
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        handleAddToCart,
        handleRemoveFromCart,
        clearCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export { CartContext, CartProvider };
